module.exports = __webpack_public_path__ + "static/media/tab_3.c0fff404.png";